module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-item ozzy-task",
    class: _vm.taskItemClass()
  }, [_c('div', {
    staticClass: "remove-task",
    on: {
      "click": _vm.removeTask
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/icons/fechar.svg")
    }
  })]), (_vm.element_options.show_contact) ? _c('div', {
    staticClass: "task-contact clickable",
    on: {
      "click": _vm.toggleTaskBar
    }
  }, [_c('div', {
    staticClass: "spacer-15"
  }), _c('div', {
    staticClass: "contact-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.task.contact.full_name))]), _c('div', {
    staticClass: "contact-business"
  }, [_vm._v(_vm._s(_vm.task.contact.business.name))])]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "interaction"
  }, [_c('span', {
    staticClass: "sent"
  }, [_vm._v(_vm._s(_vm.interaction_total_delivery))]), _c('span', {
    staticClass: "opened"
  }, [_vm._v(_vm._s(_vm.interaction_total_open))])]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "task-text"
  }, [_c('div', {
    staticClass: "task-description overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.task_description))]), _c('div', {
    staticClass: "task-info overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.task_info))])]), _c('div', {
    staticClass: "task-action-bar"
  }, [(_vm.element_options.show_comment && _vm.task.comment) ? _c('div', {
    staticClass: "comment-task-action task-comment-icon",
    class: {
      'comment-icon-down': _vm.task.isEmailTask()
    },
    attrs: {
      "id": _vm.element_id
    }
  }) : _vm._e(), (_vm.task.isEmailTask()) ? _c('div', {
    staticClass: "edit-task-action email-send-icon",
    on: {
      "click": _vm.emitOpenCompose
    }
  }) : _vm._e(), (_vm.show_call_button) ? _c('div', {
    staticClass: "phone-task-action clickable"
  }, [_c('span', {
    staticClass: "dropdown-toggle glyphicon glyphicon-earphone",
    attrs: {
      "data-toggle": "dropdown"
    }
  }), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.task.contact.cellphone) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openDialer(_vm.task.contact.cellphone, "cellphone", _vm.task)
      }
    }
  }, [_vm._v("Ligar para celular " + _vm._s(_vm.normalizePhone(_vm.task.contact.cellphone)))])]) : _vm._e(), (_vm.task.contact.telephone) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openDialer(_vm.task.contact.telephone, "telephone", _vm.task)
      }
    }
  }, [_vm._v("Ligar para telefone fixo " + _vm._s(_vm.normalizePhone(_vm.task.contact.telephone)))])]) : _vm._e(), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openDialer(null, "", _vm.task)
      }
    }
  }, [_vm._v("Ligar para outro número")])])])]) : _vm._e(), (!_vm.disable_toggle_done) ? _c('div', {
    staticClass: "done-menu glyphicon glyphicon-ok-circle clickable",
    on: {
      "click": _vm.toggleDone
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5654c91c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/ozzy_tasks/list_item.vue
// module id = 1122
// module chunks = 1